// extracted by mini-css-extract-plugin
module.exports = {"numberedList":"numbered-list_numberedList__1MD6m","number":"numbered-list_number__2OJZL","numberInverted":"numbered-list_numberInverted__OssGL","text":"numbered-list_text__2IXOS"};